__turbopack_context__.v({
  "content": "tooltip-module-scss-module__lgM1oa__content",
  "icon": "tooltip-module-scss-module__lgM1oa__icon",
  "text": "tooltip-module-scss-module__lgM1oa__text",
  "title": "tooltip-module-scss-module__lgM1oa__title",
  "title-icon": "tooltip-module-scss-module__lgM1oa__title-icon",
  "wrapper": "tooltip-module-scss-module__lgM1oa__wrapper",
});
